import { tabAccessControl } from "../../../_helpers/access-control";

let WorkOrderTabs = [
  {
    text: "Sales Awaiting Planning",
    path: `/sales-awaiting-planning`,
    applicationFeatureCode: "SalesOrderPlanning",
  },
  {
    text: "All",
    path: `/work-order`,
    applicationFeatureCode: "WorkOrder",
  },
  {
    text: "Draft",
    path: '/work-order-draft',
    applicationFeatureCode: "WorkOrder", // TODO : Change Accordingly
  },
  {
    text: "Open",
    path: '/work-order-open',
    applicationFeatureCode: "WorkOrder", // TODO : Change Accordingly
  },
  {
    text: "Completed",
    path: "/work-order-completed",
    applicationFeatureCode: "WorkOrder", // TODO : Change Accordingly
  },
  {
    text: "Material Issues",
    path: "/work-order-material-issues",
    applicationFeatureCode: "WorkOrderMaterialIssue", // TODO : Change Accordingly
  },

  {
    text: "Releases",
    path: "/releases-list",
    applicationFeatureCode: "WorkOrderProductionRelease", // TODO : Change Accordingly
  },
  {
    text: "Bulk Update",
    path: "/work-order-bulk-update",
    applicationFeatureCode: "BulkWOUpdate",
  },
  {
    text: "Actual Costs",
    path: "/work-order-actual-costs",
    applicationFeatureCode: "WorkOrder",
  },
];

function GetIndexByTabName(tabName) {
  return tabAccessControl(WorkOrderTabs).findIndex((x) => x.text == tabName);
}

export { WorkOrderTabs, GetIndexByTabName };
